import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { Box } from "@mui/material";
import SelectAdmin from "./SelectAdmin";
import UsersManagement from "./UsersManagement";

export default function ProcurementSettings() {
  const { procurement } = useOutletContext();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (!(procurement.canWrite || procurement.canWriteParams)) return <></>;

  return (
    <div className="flex flex-col space-y-6 h-full min-h-0">
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          {(procurement.canWriteParams || procurement.canWrite) && <Tab icon={<SupervisorAccountIcon />} label="Gestion des utilisateurs" />}
          {procurement.canWriteParams && <Tab icon={<VerifiedUserIcon />} label="Choix Administrateur" />}
        </Tabs>
      </Box>

      <div className="flex-1 min-h-0">
        {tabValue === 0 && <UsersManagement />}
        {tabValue === 1 && <SelectAdmin />}
      </div>
    </div>
  );
}
